import { FunctionalComponent, h } from 'preact'
import ButtonControlSelector from '../button-control-selector'

interface Props {
  showEvent: boolean
  inGroup?: number
  noWrap?: boolean
}

const TopicSelector: FunctionalComponent<Props> = ({ showEvent, inGroup, noWrap }: Props) => {
  const urlSuffix = inGroup ? `group=${inGroup}` : ''
  const getSelectorItems = () => {
    const contentTypes = [
      {
        isPrincipal: true,
        title: 'New article',
        href: `/content/new/article?${urlSuffix}`
      },
      {
        title: 'New conversation',
        href: `/topic/new?content_type=discussion&${urlSuffix}`
      },
      {
        title: 'New question',
        href: `/topic/new?content_type=question&${urlSuffix}`
      }
    ]

    if (showEvent) {
      contentTypes.push({
        title: 'New event',
        href: '/content/new/event'
      })
    }

    return contentTypes
  }

  if (noWrap) return <ButtonControlSelector items={getSelectorItems()} />

  return (
    <div>
      <ButtonControlSelector items={getSelectorItems()} />
    </div>
  )
}

export default TopicSelector
